<ng-container thr-parent-form>
    <input type="checkbox" class="d-none" [name]="prefix + 'OneFatcaManager'" [ngModel]="fatcaManagersComplete" required />

    <table class="table participants mb-4" *ngIf="fatca.managers.length > 0">
        <thead>
            <tr>
                <th>{{ 'form.person-in-control'|translate }}</th>
                <th width="90px"></th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-manager [ngForOf]="fatca.managers">
                <tr>
                    <td>
                        <strong>{{ manager.name }}</strong>
                    </td>
                    <td class="text-right">
                        <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(manager)" *ngIf="!isDisabled">
                            <i class="icon-edit"></i>
                        </button>
                        <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onRemove(manager)" *ngIf="!isDisabled">
                            <i class="icon-delete"></i>
                        </button>
                    </td>
                </tr>
            </ng-template>
        </tbody>
    </table>

    <ng-container *ngIf="!adding && !editing">
        <div class="row justify-content-between" *ngIf="!isDisabled">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray"
                        (click)="onAdd()">
                    {{ 'general.add-other'|translate }}
                </button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="adding || editing">
        <p>{{ 'full-data.indicates-person-exercising-control'|translate }}</p>
        <mat-form-field class="full-width mb-3 mb-sm-4">
            <input [name]="prefix + 'FatcaName'" matInput [placeholder]="'form.person-in-control'|translate" required
                   [disabled]="isDisabled" [(ngModel)]="currentFatcaManager.name" #fatcaNameCtrl="ngModel">
            <mat-error *ngIf="fatcaNameCtrl.hasError('required')">
                {{ 'form.validation.required'|translate }}
            </mat-error>
        </mat-form-field>

        <div class="row justify-content-between" *ngIf="!isDisabled">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray"
                        (click)="onCancel()" *ngIf="fatca.managers.length > 0">
                    {{ 'general.cancel'|translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4" [ngClass]="{'mt-3 mt-sm-0': fatca.managers.length > 0}">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue"
                        [disabled]="!currentFatcaManager || !currentFatcaManager.name" (click)="onSave()">
                    {{ 'general.add'|translate }}
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>
